import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ResetEmail from './ResetEmail';
import ResetPassword from './ResetPassword';
import RecoverEmail from './RecoverEmail';
import VerifyEmail from './VerifyEmail';

export default function ResetIndex() {
  const [mode, setMode] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentMode = params.get('mode');
    setMode(currentMode || '');
  }, [location.search]);

  if (mode === 'verifyAndChangeEmail') {    return <ResetEmail />;
  } else if (mode === 'resetPassword') {
    return <ResetPassword />;
  } else if (mode === 'recoverEmail') {
    return <RecoverEmail />;
  } else if (mode === 'verifyEmail') {
    return <VerifyEmail />;
  } else {
    return null;
  }
}